import { useEffect, useState } from "react";
import { DownloadIcon, Share2Icon, Trash2Icon } from "lucide-react";

export default function VideoCard({ setVideo }) {
  const sampleVideos = [
    {
      url: "https://www.w3schools.com/html/mov_bbb.mp4",
      text: "Sample Video 1",
    },
    {
      url: "https://media.w3.org/2010/05/sintel/trailer_hd.mp4",
      text: "Sample Video 2",
    },
  ];

  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    const randomVideo =
      sampleVideos[Math.floor(Math.random() * sampleVideos.length)];
    setSelectedVideo(randomVideo);
    setVideo(randomVideo.url);
  }, []);

  const handleShare = () => {
    if (!selectedVideo?.url) return;
    navigator.clipboard.writeText(selectedVideo.url);
    alert("Video link copied to clipboard!");
  };

  const handleDownload = () => {
    if (!selectedVideo?.url) return;
    const a = document.createElement("a");
    a.href = selectedVideo.url;
    a.download = selectedVideo.text || "video.mp4";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleDelete = () => {
    setSelectedVideo(null);
    setVideo(null);
  };

  return (
    <div className="border rounded-xl shadow-sm p-4 bg-white space-y-4 relative">
      {/* Video */}
      <div className="relative group">
        {selectedVideo?.url ? (
          <video
            src={selectedVideo.url}
            controls
            playsInline
            className="w-full rounded-md"
          />
        ) : (
          <div className="w-full h-48 bg-gray-200 flex items-center justify-center rounded-md text-gray-500">
            No video selected
          </div>
        )}

        {/* Icons */}
        <div className="absolute top-2 right-2 flex flex-col gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            className="bg-black/50 p-2 rounded-full text-white hover:bg-black/70"
            onClick={handleShare}
          >
            <Share2Icon size={18} />
          </button>
          <button
            className="bg-black/50 p-2 rounded-full text-white hover:bg-black/70"
            onClick={handleDownload}
          >
            <DownloadIcon size={18} />
          </button>
          <button
            className="bg-black/50 p-2 rounded-full text-white hover:bg-black/70"
            onClick={handleDelete}
          >
            <Trash2Icon size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
